import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchStagingBuilders } from "../redux";
import { fillStagingBuilderFromRefresh } from "../redux/stagingBuilder/actions/fillStagingBuilderFromRefresh";

export const LoadStagingBuilders = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    // Apply default filters on initial load to reduce data size
    // Hide closed (0) and staged (0) by default
    const defaultFilters = {
      showClosed: 0 as 0 | 1 | 2,
      showStaged: 0 as 0 | 1 | 2,
      showRequests: 1 as 0 | 1 | 2,
    };

    dispatch(fetchStagingBuilders(defaultFilters) as any);
    dispatch(fillStagingBuilderFromRefresh());
  }, [dispatch]);
  return null;
};
